var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schedule",
    clipPath: "url(#clip0_60966_13576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9925 3C9.705 3 3 9.7125 3 18C3 26.2875 9.705 33 17.9925 33C26.28 33 33 26.2875 33 18C33 9.7125 26.28 3 17.9925 3ZM18 30C11.37 30 6 24.63 6 18C6 11.37 11.37 6 18 6C24.63 6 30 11.37 30 18C30 24.63 24.63 30 18 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.75 11.5C18.75 10.9477 18.3023 10.5 17.75 10.5H17.5C16.9477 10.5 16.5 10.9477 16.5 11.5V18.9341C16.5 19.2852 16.6841 19.6106 16.9851 19.7914L23.5185 23.7151C23.9887 23.9975 24.5987 23.8484 24.8856 23.381L24.969 23.2451C25.2609 22.7695 25.107 22.1468 24.627 21.862L19.2397 18.6656C18.9361 18.4854 18.75 18.1586 18.75 17.8056V11.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60966_13576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.bdc132ea1adf8b96f84103dfaa433d3f.svg";
export { ForwardRef as ReactComponent };